import { render, staticRenderFns } from "./ReportXiaoshan.vue?vue&type=template&id=40637fe4&scoped=true"
import script from "./ReportXiaoshan.vue?vue&type=script&lang=js"
export * from "./ReportXiaoshan.vue?vue&type=script&lang=js"
import style0 from "./ReportXiaoshan.vue?vue&type=style&index=0&id=40637fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40637fe4",
  null
  
)

export default component.exports